var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttach = function SvgAttach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.454 7.91-6.272 6.272a3.085 3.085 0 1 1-4.364-4.364L10.636 3a1.928 1.928 0 1 1 2.728 2.727l-5.728 5.727c-.3.3-.79.3-1.09 0-.3-.3-.3-.79 0-1.09l5.181-5.182-.818-.818-5.182 5.181a1.928 1.928 0 1 0 2.728 2.728l5.727-5.728a3.085 3.085 0 1 0-4.364-4.363L3 9a4.24 4.24 0 0 0 0 6 4.24 4.24 0 0 0 6 0l6.273-6.273-.819-.818Z",
    fill: "#606060",
    stroke: "#606060",
    strokeWidth: 0.3,
    strokeLinejoin: "round"
  })));
};
export default SvgAttach;